var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRawMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pelletGrad",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a0c3d2",
    stopOpacity: 0.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 50,
    r: 3,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 53,
    r: 2.8,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 50,
    r: 3.2,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 54,
    r: 3,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 52,
    r: 3.1,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 55,
    r: 2.7,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 51,
    r: 3,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 58,
    r: 2.9,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 60,
    r: 3.2,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 59,
    r: 2.6,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 58,
    r: 3,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 60,
    r: 2.8,
    fill: "url(#pelletGrad)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 59,
    r: 3.1,
    fill: "url(#pelletGrad)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawMaterial);
export default __webpack_public_path__ + "static/media/raw-material.74bd2da1efe6d9d9adb32ffe24e7a106.svg";
export { ForwardRef as ReactComponent };